import * as actions from './actions';
import * as getters from './getters';
import moment from 'moment';

import {
    CREATE_QUOTE,
    CLEAR_QUOTE,
    FETCH_BOOKING,
    FETCH_MODIFICATION,
    FETCH_LAST_MODIFICATION,
    FETCH_RENTAL_CODE,
    FETCH_MODIFICATION_EXTRAS,
    FETCH_NEW_QUOTE,
    UPDATED_BOOKING,
    FETCH_CURRENCIES,
    FETCH_LOCATIONS,
    SET_CURRENCY,
    SET_CURRENCY_CHANGE_TOKEN,
    REGISTER_VEHICLE_LISTING,
    UNREGISTER_VEHICLE_LISTING,
    DELETE_VEHICLE,
    FETCH_VEHICLES,
    APPEND_VEHICLES,
    SET_VEHICLES_TOTAL,
    SET_VEHICLES_REQUEST_TOKEN,
    SET_PAGINATION_DATA,
    SET_VEHICLE_FACETS,
    SET_FACETS_REQUEST_TOKEN,
    CLEAR_VEHICLES,
    FETCH_VEHICLE_INSURANCE_OPTIONS,
    CREATE_EXTRA,
    DELETE_EXTRA,
    FETCH_EXTRAS,
    FETCH_SELECTED_EXTRAS,
    UPDATE_DONATION,
    UPDATE_PAYMENT_TYPE,
    FETCH_TOTALS,
    SET_GRAND_TOTAL,
    FETCH_DONATIONS,
    FETCH_LOYALTY_LEVELS,
    SET_CUSTOMER,
    SET_CUSTOMER_STATE,
    SET_PICKUP_DATE,
    SET_PICKUP_TIME,
    SET_DROPOFF_DATE,
    SET_DROPOFF_TIME,
    SET_PICKUP_LOCATION,
    SET_DROPOFF_LOCATION,
    CREATE_BOOKING,
    TOGGLE_PREMIUM_VEHICLE_UPGRADE,
    SET_SELECTED_VEHICLE_TYPE,
    SET_LOADING,
    SET_TAB,
    SET_CURRENCY_REFRESHING,
} from './mutation-types';

// initial state
const initialState = {
    quote: {
        id: null,
        source_id: null,
        pickup_location: {
            data: {
                id: null,
                name: null,
            },
        },
        pickup_location_id: null,
        dropoff_location: {
            data: {
                id: null,
                name: null,
            },
        },
        dropoff_location_id: null,
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        age: null,
        promo_code: null,
        loyalty_discount: null,
        birthday_loyalty_discount_applied: null,
        green_heart_donation: false,
        currency: null,
        converted_currency: null,
        locale: null,
        guest_token: null,
        payment_type: 'PP',
        pay_on_arrival_available: true,
        customer: null,
        selected_vehicle: {
            data: {
                id: null,
                total: 0,
                vehicle: {
                    data: {
                        acriss: null,
                        adults: 0,
                        air_conditioning: 0,
                        children: 0,
                        co2: 0,
                        currency: null,
                        discount: 0,
                        discount_percentage: null,
                        excess: 0,
                        fuel: null,
                        group: null,
                        id: null,
                        image: null,
                        loyalty_discount_applied: null,
                        luggage_large: 0,
                        luggage_medium: 0,
                        luggage_small: 0,
                        mpg: null,
                        name: null,
                        original_price: 0,
                        poa_deposit: 0,
                        total_poa: 0,
                        total_pp: 0,
                        transmission: null,
                        charge_totals: [],
                    },
                },
                selected_insurance_options: {
                    data: [],
                },
            },
        },
        selected_extras: {
            data: [],
        },
        totals: {
            data: {
                green_heart_donation: 0,
                pay_on_arrival: 0,
                pay_online: 0,
                total: 0,
                grand_total: 0,
            },
        },
    },
    vehicles: [],
    vehiclesTotal: 0,
    vehiclesRequestToken: 0,
    paginationData: null,
    vehicleFacets: null,
    facetsRequestToken: 0,
    // Bumped by setCurrencyState alongside SET_CURRENCY, so components that need to
    // react to a currency change (not just display reactive getters) can watch one
    // dedicated signal instead of the general vehiclesRequestToken - which also bumps
    // on every filter/sort/pagination fetch unrelated to currency.
    currencyChangeToken: 0,
    // How many mounted Vehicles.vue listings currently own the vehicle list. While one
    // does, a currency change leaves the vehicle refetch to it (so it can keep its
    // filters, sort and loaded pages) instead of fetching a generic list itself. A
    // count rather than a flag so an outgoing instance unregistering after the
    // incoming one registers (route transitions) can't clear it.
    vehicleListingOwners: 0,
    currencyCode: 'GBP',
    currency: {
        code: window.greenmotion.kayakQuoteCurrency || localStorage.getItem('currency') || window.greenmotion.defaultCurrency || 'GBP',
        name: 'Pound Sterling',
        symbol: '£',
    },
    currencies: [
        {
            code: 'EUR',
            name: 'Euro',
            symbol: '€',
        },
        {
            code: 'USD',
            name: 'US Dollar',
            symbol: '$',
        },
        {
            code: 'GBP',
            name: 'Pound Sterling',
            symbol: '£',
        },
        {
            code: 'JPY',
            name: 'Japanese Yen',
            symbol: '¥',
        },
        {
            code: 'TRY',
            name: 'Turkish Lira',
            symbol: '₺',
        },
    ],
    locations: [],
    vehicleInsuranceOptions: [],
    hasUpgradedVehicle: false,
    selectedVehicleType: 'basic',
    extras: [],
    search: {
        pickupLocation: null,
        dropoffLocation: null,
        pickupDate: moment().format('YYYY-MM-DD'),
        pickupTime: '09:00',
        dropoffDate: moment().format('YYYY-MM-DD'),
        dropoffTime: '09:00',
        driverAge: null,
        promoCode: '',
    },
    createDirect: true,
    donations: [],
    loyaltyLevels: [],
    booking: {
        id: null,
        quote_id: null,
        hasUpdate: false,
        utc_pickup_datetime: null,
        original_donation_total: 0,
        amount_paid: 0,
        amount_paid_gbp: 0,
        amount_currency: '',
        has_basic_free_cancellation: false,
    },
    modification: {
        changes: {
            isPartial: false,
            modification: {},
            changes: '',
            rental_code: '',
            cust_info: [],
            extras: [],
            options_result: '',
            vehicle_total: 0,
            options_total: 0,
            grand_total: 0,
            pay_online: 0,
            pay_online_with_donation: 0,
        },
        new_quote: {},
        current_quote: {},
        rental_code: null,
    },
    lastModification: {
        changes: {
            isPartial: false,
            modification: {},
            changes: '',
            rental_code: '',
            cust_info: [],
            extras: [],
            options_result: '',
            vehicle_total: 0,
            options_total: 0,
            grand_total: 0,
            pay_online: 0,
            pay_online_with_donation: 0,
        },
        new_quote: {},
        current_quote: {},
        rental_code: null,
    },
    bookingUpdating: false,
    loading: true,
    currencyRefreshing: false,
    tab: 'vehicles-list',
};

// mutations
const mutations = {
    [CREATE_QUOTE](state, quote) {
        state.quote = quote;

        let currencyCode = quote.user !== undefined || quote.converted_currency ? quote.converted_currency : quote.user_location_currency;

        state.currencyCode = currencyCode || quote.pickup_location_currency;
        const currency = state.currencies.filter((currency) => {
            return currency.code === quote.converted_currency;
        });

        if (currency.length) {
            state.currency = currency[0];
        }

        // Set search params
        state.search.pickupLocation = quote.pickup_location;
        state.search.dropoffDifferent = true;
        state.search.dropoffLocation = quote.dropoff_location;
        state.search.pickupDate = quote.start_date;
        state.search.pickupTime = quote.start_time;
        state.search.dropoffDate = quote.end_date;
        state.search.dropoffTime = quote.end_time;
        state.search.driverAge = quote.age;
        state.search.promoCode = quote.promo_code;
    },

    [SET_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_CURRENCY_REFRESHING](state, refreshing) {
        state.currencyRefreshing = refreshing;
    },

    [CLEAR_QUOTE](state) {
        Object.keys(initialState).forEach((key) => {
            // These are monotonic generation counters, not resettable data - resetting
            // them to 0 here would let a request already in flight for the quote being
            // cleared (which captured some token N) collide with a freshly-issued
            // request for the next quote that also captures N, passing its stale
            // response through the equality check below.
            if (key === 'vehiclesRequestToken' || key === 'facetsRequestToken') {
                return;
            }
            // Not request guards, so left untouched: currencyChangeToken is a change
            // notification (bumping it would fire the currency watchers on every ordinary
            // quote setup), and vehicleListingOwners tracks mounted components, which a
            // quote clear doesn't unmount.
            if (key === 'currencyChangeToken' || key === 'vehicleListingOwners') {
                return;
            }
            state[key] = initialState[key];
        });
        // Bump instead of reset, so old in-flight requests can never match a token
        // issued after this point.
        state.vehiclesRequestToken += 1;
        state.facetsRequestToken += 1;
    },

    [FETCH_BOOKING](state, booking) {
        if (booking) {
            state.booking.id = booking.id;
            state.booking.reference = booking.reference;
            state.booking.quote_id = booking.quote_id;
            state.booking.total = booking.total;
            state.booking.hasUpdate = booking.hasUpdate;
            state.booking.utc_pickup_datetime = booking.utc_pickup_datetime;
            state.booking.original_donation_total = booking.original_donation_total;
            state.booking.amount_paid = booking.amount_paid;
            state.booking.amount_paid_gbp = booking.amount_paid_gbp;
            state.booking.amount_currency = booking.amount_currency;
            state.booking.can_be_modified = booking.can_be_modified;
            state.booking.confirmed_extras = booking.confirmed_extras || [];
            state.booking.quote = booking.quote || {};
            state.booking.has_basic_free_cancellation = booking.has_basic_free_cancellation || false;
            state.booking.is_free_product_upgrade_applied = booking.is_free_product_upgrade_applied || false;
            state.booking.has_modification_in_progress = booking.has_modification_in_progress || false;
        }
    },

    [FETCH_MODIFICATION](state, response) {
        state.modification.changes = response;
    },

    [FETCH_LAST_MODIFICATION](state, response) {
        state.lastModification.changes = response;
    },

    [FETCH_RENTAL_CODE](state, rentalCode) {
        state.modification.rental_code = rentalCode;
    },

    [FETCH_NEW_QUOTE](state, response) {
        state.modification.new_quote = response;
    },

    [FETCH_MODIFICATION_EXTRAS](state, response) {
        state.modification.changes.extras = response;
    },

    [UPDATED_BOOKING](state, value) {
        state.bookingUpdating = value;
    },

    [FETCH_CURRENCIES](state, currencies) {
        state.currencies = currencies;
    },

    [FETCH_LOCATIONS](state, locations) {
        state.locations = locations;
    },

    [SET_CURRENCY](state, currency) {
        state.currency = currency;
        state.search.currency = currency;
    },

    [SET_CURRENCY_CHANGE_TOKEN](state, token) {
        state.currencyChangeToken = token;
    },

    [REGISTER_VEHICLE_LISTING](state) {
        state.vehicleListingOwners += 1;
    },

    [UNREGISTER_VEHICLE_LISTING](state) {
        state.vehicleListingOwners = Math.max(0, state.vehicleListingOwners - 1);
    },

    [FETCH_VEHICLES](state, vehicles) {
        state.vehicles = vehicles;
    },

    [APPEND_VEHICLES](state, vehicles) {
        const existingIds = new Set(state.vehicles.map((vehicle) => vehicle.id));

        state.vehicles = [...state.vehicles, ...vehicles.filter((vehicle) => !existingIds.has(vehicle.id))];
    },

    [SET_VEHICLES_TOTAL](state, total) {
        state.vehiclesTotal = total;
    },

    [SET_VEHICLES_REQUEST_TOKEN](state, token) {
        state.vehiclesRequestToken = token;
    },

    [SET_PAGINATION_DATA](state, pagination) {
        // Allow callers to clear pagination when the API response doesn't include pagination meta.
        if (!pagination) {
            state.paginationData = null;
            return;
        }

        const { per_page, current_page, total_pages } = pagination;
        state.paginationData = { per_page, current_page, total_pages };
    },

    [SET_VEHICLE_FACETS](state, facets) {
        state.vehicleFacets = facets;
    },

    [SET_FACETS_REQUEST_TOKEN](state, token) {
        state.facetsRequestToken = token;
    },

    [CLEAR_VEHICLES](state) {
        state.vehicles = [];
        state.vehiclesTotal = 0;
        // Invalidate any in-flight fetchVehicles/fetchMoreVehicles requests so a stale
        // response can't repopulate the list we just cleared.
        state.vehiclesRequestToken += 1;
        // Same for any in-flight fetchVehicleFacets request.
        state.facetsRequestToken += 1;
        state.paginationData = null;
        state.vehicleFacets = null;
    },

    [FETCH_VEHICLE_INSURANCE_OPTIONS](state, insuranceOptions) {
        state.vehicleInsuranceOptions = insuranceOptions;
    },

    [CREATE_EXTRA](state, payload) {
        state.selectedExtras.push(payload.selectedExtra);
        state.selectedExtraIds.push({
            selectedExtraId: payload.selectedExtraId,
            extraId: payload.selectedExtra.id,
        });
    },

    [DELETE_EXTRA](state, selectedExtra) {
        state.quote.selected_extras.data = state.quote.selected_extras.data.filter((extra) => {
            return extra.id !== selectedExtra.id;
        });
    },

    [FETCH_EXTRAS](state, extras) {
        state.extras = extras;
    },

    [FETCH_SELECTED_EXTRAS](state, extras) {
        state.quote.selected_extras = extras;
    },

    [UPDATE_DONATION](state, donate) {
        state.donate = donate;
    },

    [UPDATE_PAYMENT_TYPE](state, payment_type) {
        state.quote.payment_type = payment_type;
    },

    [FETCH_TOTALS](state, totals) {
        state.totals = totals;
    },

    [SET_GRAND_TOTAL](state, total) {
        if (state?.quote?.totals?.data) {
            state.quote.totals.data.grand_total = total;
        } else {
            state.quote['totals'] = {
                data: {
                    grand_total: total,
                },
            };
        }
    },

    [FETCH_DONATIONS](state, donations) {
        state.donations = donations;
    },

    [FETCH_LOYALTY_LEVELS](state, loyaltyLevels) {
        state.loyaltyLevels = loyaltyLevels;
    },

    [SET_CUSTOMER_STATE](state, payload) {
        state.customer[payload.key] = payload.value;
    },

    [SET_CUSTOMER](state, customer) {
        state.quote.customer = customer;
    },

    [DELETE_VEHICLE](state) {
        state.quote.selected_vehicle = initialState.quote.selected_vehicle;
    },

    [SET_PICKUP_DATE](state, date) {
        state.search.pickupDate = date;
    },

    [SET_PICKUP_TIME](state, time) {
        state.search.pickupTime = time;
    },

    [SET_DROPOFF_DATE](state, date) {
        state.search.dropoffDate = date;
    },

    [SET_DROPOFF_TIME](state, time) {
        state.search.dropoffTime = time;
    },

    [SET_PICKUP_LOCATION](state, location) {
        state.search.pickupLocation = location;
    },

    [SET_DROPOFF_LOCATION](state, dateTime) {
        state.search.dropoffLocation = dateTime;
    },

    [CREATE_BOOKING](state, booking) {
        state.booking = booking;
    },

    [TOGGLE_PREMIUM_VEHICLE_UPGRADE](state) {
        state.hasUpgradedVehicle = !state.hasUpgradedVehicle;
    },

    [SET_SELECTED_VEHICLE_TYPE](state, type) {
        state.selectedVehicleType = type;
        state.hasUpgradedVehicle = false;
    },

    [SET_TAB](state, tab) {
        state.tab = tab;
    },
};

export default {
    state: { ...initialState },
    actions,
    getters,
    mutations,
};
